import _Object$setPrototypeOf from "core-js/library/fn/object/set-prototype-of.js";
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = _Object$setPrototypeOf ? _Object$setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
export { _setPrototypeOf as default };


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/helpers/esm/setPrototypeOf.js
// module id = 1452
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16